export const REFERRAL_LINK_PARAMS_STORAGE_KEY = 'fbs:composedReferralData'
export const REFERRAL_LINK_TTL_IN_DAYS = 30;
export const siteReferralData = 'fbs:referralLink';
